import React from 'react';
import { connect } from 'react-redux';
import { Progress, Icon } from 'antd';
import CONSTANT from '../../../constant';

/**
 * 更新软件下载进度
 * 
 * @param {any} { intlr, updater } 
 * @returns 
 */
const UpdaterProgress = ({ intlr, updater }) => {
  const { messages } = intlr;
  const { progress } = updater;
  if (!progress) {
    return null;
  }
  const { percent, status } = progress;
  const showText = () => {
    if (status === CONSTANT.UPLOAD_STATUS.FAILED) {
      return (
        <span className="ml text error">
          <Icon className="mr" type="warning" />
          {messages['UPDATER.PROGRESS.ERROR']}
        </span>
      );
    } else {
      return (
        <span className="ml text">{messages['UPDATER.PROGRESS.PERCENT'].format(percent)}</span>
      );
    }
  };
  const getProgressStatus = () => {
    if (status === CONSTANT.UPLOAD_STATUS.FAILED) {
      return 'exception';
    }
    if (status === CONSTANT.UPLOAD_STATUS.DONE) {
      return 'success';
    }
    return 'active';
  };
  return (
    <div className="flex-row updater-progress-container">
      <Progress
        size="small"
        showInfo={false}
        status={getProgressStatus()}
        percent={percent}
        style={{
          width: '10rem'
        }} />
      {showText()}
    </div>
  );
};

const mapStateToProps = state => ({
  intlr: state.intlr,
  updater: state.updater
});


export default connect(
  mapStateToProps,
)(UpdaterProgress);
